module.exports = __webpack_public_path__ + "static/media/Bounce.a9cee4aa.svg";